module.exports = __webpack_public_path__ + "static/media/rules-outline.7ed913e3.svg";